(function () {
  function setupKlaviyoClose() {
    const teaser = document.querySelector('[data-testid="animated-teaser"]');

    if (!teaser) return;

    const container = teaser.parentElement;

    if (!container) return;

    // Prevent duplicate X button
    if (container.querySelector('.custom-klaviyo-close')) return;

    // Create X button
    const closeButton = document.createElement('button');

    closeButton.className = 'custom-klaviyo-close';
    closeButton.innerHTML = '&times;';
    closeButton.setAttribute('aria-label', 'Close');

    // Style the X
    Object.assign(closeButton.style, {
      position: 'absolute',
      top: '-10px',
      right: '-10px',
      width: '30px',
      height: '30px',
      padding: '0',
      margin: '0',
      border: '0',
      borderRadius: '50%',
      backgroundColor: '#000',
      color: '#fff',
      fontSize: '22px',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '30px',
      textAlign: 'center',
      cursor: 'pointer',
      zIndex: '999999',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    });

    // Close button click
    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      container.style.display = 'none';
    });

    container.appendChild(closeButton);
  }

  // Try immediately
  setupKlaviyoClose();

  // Watch for Klaviyo loading dynamically
  const observer = new MutationObserver(function () {
    setupKlaviyoClose();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();